export interface IAttachment {
  createdAt?: string
  id: string
  file?: any
  fileName: string
  temporalPath: string
  path: string
  size: number
  contentType: string
  comments?: string
  status: IAttachmentStatus
  processing: boolean
  error?: string
  uploaded?: boolean
  uploadUrl?: string
  downloadUrl?: string
}

export enum IAttachmentStatus {
    NEW = 'NEW',
    UPDATE = 'UPDATE',
    SAVED = 'SAVED',
    ERROR = 'ERROR',
}

export interface IMediaUploadRequestDto {
  signedUrl: string
  file: any
  contentType: string
}
export interface IMediaUploadResponseDto {
  signedUrl: string
  file: any
  contentType: string
}

export interface IMediaUploadSignedUrlRequestDto {
  fileId: string
  contentType: string
}

export interface IMediaUploadSignedUrlResponseDto {
  createdBy: string
  createdAt: string
  organizationId: string
  clientId: string
  fileId: string
  contentType: string
  path: string
  url: string
}

export interface IMediaDownloadRequestDto {
  createdBy?: string
  createdAt?: string
  organizationId?: string
  path: string
  fileId: string
}

export interface IMediaDownloadResponseDto {
  createdBy?: string
  createdAt?: string
  organizationId?: string
  path: string
  url: string
}

export interface IMediaDownloadSignedUrlRequestDto {
  fileId: string
  path: string
}

export interface IMediaDownloadSignedUrlResponseDto {
  createdBy: string
  createdAt: string
  organizationId: string
  clientId: string
  fileId: string
  path: string
  url: string
}
